import { type IActionOf } from '../../../../types';
import { Actions } from '../constants';
import { type IInitVideoAdPayload, type ILoadVideoAdPayload } from '../types';

export function loadVideoAd(
  data?: ILoadVideoAdPayload,
): IActionOf<Actions.LOAD_VIDEO_AD, ILoadVideoAdPayload | undefined> {
  return { type: Actions.LOAD_VIDEO_AD, data };
}

export function unloadVideoAd(): IActionOf<Actions.UNLOAD_VIDEO_AD> {
  return { type: Actions.UNLOAD_VIDEO_AD };
}

export function showVideoAd(): IActionOf<Actions.SHOW_VIDEO_AD> {
  return { type: Actions.SHOW_VIDEO_AD };
}

export function hideVideoAd(): IActionOf<Actions.HIDE_VIDEO_AD> {
  return { type: Actions.HIDE_VIDEO_AD };
}

export function initVideoAd(
  data: IInitVideoAdPayload,
): IActionOf<Actions.INIT_VIDEO_AD, IInitVideoAdPayload> {
  return {
    type: Actions.INIT_VIDEO_AD,
    data,
  };
}
